module.exports = __webpack_public_path__ + "img/level-1.7fa55d77.jpg";